// Lightweight click-sound utility for primary CTA buttons.
// Uses a tiny inline WAV (base64) — no external file needed.
// Honors prefers-reduced-motion (treated as "prefer quiet" too).

let _audio = null;
let _muted = false;

// Soft click — short 60ms sine blip generated at 880Hz with quick fade-out.
// Encoded as a small wav data URI.
const CLICK_DATA_URI =
  "data:audio/wav;base64,UklGRiQEAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAEAAAAAAEABwEUASkBQAFcAXkBlwG3AdkB+QEcAjwCWwJ5ApYCsALMAuMC+QIMAx0DKwM2Az0DQQNFA0QDQAM5AzADJAMVAwQD8wLeAsgCsAKWAnwCXgJBAiQCBQLnAcsBrgGRAXMBVQE5ARwBAQHnAM4AtwCgAIsAdgBjAFAAQAAvACAAEgAFAPv/8f/o/+H/2v/V/9H/zv/M/8v/y//N/8//0v/W/9v/4f/n/+7/9v/+/wYAEAAaACQALwA7AEcAUwBgAG0AewCJAJgApwC2AMUA1QDmAPYABgEXASkBOwFNAV8BcQGEAZcBqQG7Ac0B3wHxAQMCFAImAjcCSAJYAmkCeAKHApYCpAKxAr4CygLVAt8C6QLxAvkCAAMGAwsDDgMRAxIDEwMSAxADDQMJAwQD/QL2Au4C5QLcAtIByQG/AbYBrAGiAZkBjwGGAX0BdAFqAWEBVwFNAUMBOAEsASABFAEHAfoA7gDhANUAyAC8ALAApACYAI0AggB4AG4AZQBcAFQATABFAD4AOAAyAC0AKAAjAB8AHAAYABYAFAASABEAEQARABEAEQATABUAFwAaAB0AIQAlACoALwA1ADwAQwBLAFMAXABlAG4AeACDAI4AmgClALEAvgDLANgA5gD0AAMBEgEhATEBQQFRAWIBcgGCAZIBowGzAcMB1AHkAfMBAwITAiICMQJAAk8CXQJqAncCgwKPApsCpgKwArkCwgLLAtICOwLZApsCdwIvAt8BowKfAukB7QGOAfgB8gIzAjsCdwL/AfsCMQILAg0DLgI8AhMDIQItAjUDeQI8AjQDfgI9AjQDgwI+AjMDhgI9AjMDhwI8AjQDhgI7AjUDhAI5AjYDgQI3AjcDfQI1AjgDeAIzAjkDcQIxAjsDaQIvAjwDXwItAj4DVQIqAj8DSQInAkAD";

function _initAudio() {
  if (_audio) return _audio;
  try {
    _audio = new Audio(CLICK_DATA_URI);
    _audio.volume = 0.18;
    _audio.preload = "auto";
  } catch {
    _audio = null;
  }
  return _audio;
}

export function setClickMuted(v) {
  _muted = !!v;
  try { localStorage.setItem("ts_click_muted", _muted ? "1" : "0"); } catch {}
}

export function isClickMuted() {
  if (_muted) return true;
  try {
    if (localStorage.getItem("ts_click_muted") === "1") return true;
  } catch {}
  if (typeof window !== "undefined" && window.matchMedia) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
  }
  return false;
}

export function playClick() {
  if (isClickMuted()) return;
  const a = _initAudio();
  if (!a) return;
  try {
    a.currentTime = 0;
    const p = a.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch {}
}
